export enum AuditType {
  CREATE = 'Created',
  UPDATE = 'Updated',
  DELETE = 'Deleted',
}

export enum TemplateMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}
